import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const EarningFeature = ({ data }) => {
  console.log("newewadnjdsds");
  return (
    <>
      <Row className="">
        <Col lg="4" sm="6" className="my-2">
          <Link to="/manage-driver" className="h-100 text-dark">
            <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative h-100">
              <span
                className="icn position-absolute"
                style={{ top: 5, right: 5 }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <rect
                    x="21.8438"
                    y="21.896"
                    width="21.4808"
                    height="21.4808"
                    rx="10.7404"
                    transform="rotate(-180 21.8438 21.896)"
                    fill="#467912"
                  />
                  <g clip-path="url(#clip0_0_2329)">
                    <path
                      d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_0_2329">
                      <rect
                        width="7.43568"
                        height="7.43567"
                        fill="white"
                        transform="translate(15.2343 14.4602) rotate(-180)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <div className="imgWrp me-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                >
                  <circle cx="32" cy="32" r="32" fill="#D9D9D9" />
                  <path
                    d="M26.952 22.9363H37.6143C38.186 22.9363 38.6596 22.4399 38.6624 21.8204C38.6624 21.8165 38.6624 21.8126 38.6624 21.8087C38.6624 20.6767 37.9318 19.6653 36.6052 18.9609C35.4381 18.3413 33.9032 18 32.2831 18C30.663 18 29.1281 18.3413 27.9609 18.9609C26.6344 19.6653 25.9038 20.6767 25.9038 21.8087C25.9038 21.8126 25.9038 21.8165 25.9039 21.8204C25.9066 22.4399 26.3802 22.9363 26.952 22.9363Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M34.2075 26.5777C35.5419 26.5777 36.6654 25.6588 36.9792 24.4206C36.9746 24.4146 36.97 24.4086 36.9654 24.4026H27.6007C27.5962 24.4086 27.5915 24.4146 27.5869 24.4206C27.9007 25.6588 29.0242 26.5777 30.3585 26.5777H34.2075Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M26.7158 26.0488C26.5072 26.6514 26.3936 27.298 26.3936 27.9707C26.3936 31.2182 29.0356 33.8602 32.2831 33.8602C35.5306 33.8602 38.1727 31.2182 38.1727 27.9707C38.1727 27.2979 38.059 26.6513 37.8504 26.0487C37.0807 27.2478 35.7354 28.044 34.2076 28.044H30.3586C28.8308 28.044 27.4856 27.2479 26.7158 26.0488Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M36.0449 36.5701V41.185L37.4801 38.8292L36.0449 36.5701Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M28.5183 41.1804V36.5745L27.0859 38.8292L28.5183 41.1804Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M29.9844 41.4115H34.5787V43H29.9844V41.4115Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M29.9844 38.479H34.5787V39.9452H29.9844V38.479Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M37.3595 33.2888C37.0195 33.6135 36.6484 33.9057 36.2515 34.1611L38.9621 38.428C39.1118 38.6636 39.1147 38.964 38.9694 39.2025L36.6559 43H42.1991C42.4016 43 42.5656 42.8359 42.5656 42.6334V42.1915C42.5657 38.377 40.4647 35.0445 37.3595 33.2888Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M25.6035 38.428L28.3142 34.1611C27.9172 33.9057 27.5461 33.6135 27.2062 33.2888C24.101 35.0445 22 38.377 22 42.1915V42.6334C22 42.8359 22.1641 43 22.3666 43H27.9097L25.5962 39.2025C25.451 38.964 25.4538 38.6636 25.6035 38.428Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M29.9844 34.9587V37.0128H34.5787V34.9597C33.856 35.1976 33.0842 35.3265 32.2829 35.3265C31.4806 35.3265 30.7078 35.1973 29.9844 34.9587Z"
                    fill="#534F4F"
                  />
                </svg>
              </div>
              <div className="content">
                <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                  {data?.numberOfDrivers}
                </h4>
                <p className="m-0 fw-sbold">Number of Drivers</p>
              </div>
            </div>
          </Link>
        </Col>
        <Col lg="4" sm="6" className="my-2">
          <Link to="/booking/my-bookings" className="h-100 text-dark">
            <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative h-100">
              <span
                className="icn position-absolute"
                style={{ top: 5, right: 5 }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <rect
                    x="21.8438"
                    y="21.896"
                    width="21.4808"
                    height="21.4808"
                    rx="10.7404"
                    transform="rotate(-180 21.8438 21.896)"
                    fill="#467912"
                  />
                  <g clip-path="url(#clip0_0_2329)">
                    <path
                      d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_0_2329">
                      <rect
                        width="7.43568"
                        height="7.43567"
                        fill="white"
                        transform="translate(15.2343 14.4602) rotate(-180)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <div className="imgWrp me-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                >
                  <circle cx="32" cy="32" r="32" fill="#D9D9D9" />
                  <g clip-path="url(#clip0_14_240)">
                    <path
                      d="M44.5232 27.9043C44.4291 27.5955 44.2164 27.3367 43.9319 27.1843C43.6473 27.0319 43.314 26.9984 43.0048 27.0912C42.6956 27.184 42.4358 27.3954 42.2821 27.6793C42.1285 27.9632 42.0935 28.2964 42.1849 28.606C42.4658 29.5449 42.6081 30.5199 42.6072 31.5C42.6072 37.0464 38.095 41.5586 32.5486 41.5586C27.0022 41.5586 22.49 37.0464 22.49 31.5C22.49 25.9536 27.0022 21.4414 32.5486 21.4414C34.5093 21.4379 36.4278 22.0101 38.0662 23.0869C38.2001 23.1773 38.3506 23.2402 38.5091 23.272C38.6675 23.3038 38.8306 23.3038 38.989 23.2721C39.1475 23.2403 39.298 23.1774 39.4319 23.0871C39.5659 22.9967 39.6805 22.8806 39.7693 22.7456C39.858 22.6106 39.9191 22.4593 39.9489 22.3005C39.9787 22.1417 39.9767 21.9786 39.943 21.8206C39.9094 21.6625 39.8446 21.5128 39.7526 21.38C39.6606 21.2472 39.5431 21.1339 39.407 21.0469C36.82 19.3483 33.6949 18.6698 30.6364 19.1427C27.578 19.6155 24.8037 21.2062 22.8505 23.6067C20.8972 26.0073 19.904 29.047 20.0629 32.1377C20.2218 35.2285 21.5216 38.1503 23.7107 40.3379C25.6801 42.3035 28.2488 43.556 31.0102 43.8973C33.7716 44.2386 36.568 43.649 38.9566 42.2221C41.3452 40.7951 43.1896 38.6121 44.1979 36.0188C45.2062 33.4255 45.3207 30.57 44.5232 27.9043Z"
                      fill="#534F4F"
                    />
                    <path
                      d="M38.2287 27.2188L30.7179 34.7315L26.8683 30.8819C26.755 30.7685 26.6204 30.6786 26.4722 30.6172C26.3241 30.5559 26.1654 30.5243 26.005 30.5243C25.8447 30.5243 25.686 30.5559 25.5378 30.6172C25.3897 30.6786 25.2551 30.7685 25.1418 30.8819C25.0284 30.9952 24.9385 31.1298 24.8771 31.278C24.8158 31.4261 24.7842 31.5848 24.7842 31.7452C24.7842 31.9055 24.8158 32.0642 24.8771 32.2124C24.9385 32.3605 25.0284 32.4951 25.1418 32.6084L29.5026 36.9688C29.8249 37.2911 30.2621 37.4722 30.7179 37.4722C31.1738 37.4722 31.6109 37.2911 31.9333 36.9688L39.9552 28.9454C40.1842 28.7164 40.3128 28.4059 40.3128 28.0821C40.3128 27.7583 40.1842 27.4477 39.9552 27.2188C39.7263 26.9898 39.4158 26.8612 39.092 26.8612C38.7682 26.8612 38.4576 26.9898 38.2287 27.2188Z"
                      fill="#534F4F"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_14_240">
                      <rect
                        width="25"
                        height="25"
                        fill="white"
                        transform="translate(20 19)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="content">
                <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                  {data?.totalCompletedBookings}
                </h4>
                <p className="m-0 fw-sbold">Total Bookings Completed </p>
              </div>
            </div>
          </Link>
        </Col>
        <Col lg="4" sm="6" className="my-2">
          <Link to="/booking/booking-request" className="h-100 text-dark">
          <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative h-100">
            <span
              className="icn position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 22 22"
                fill="none"
              >
                <rect
                  x="21.8438"
                  y="21.896"
                  width="21.4808"
                  height="21.4808"
                  rx="10.7404"
                  transform="rotate(-180 21.8438 21.896)"
                  fill="#467912"
                />
                <g clip-path="url(#clip0_0_2329)">
                  <path
                    d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_2329">
                    <rect
                      width="7.43568"
                      height="7.43567"
                      fill="white"
                      transform="translate(15.2343 14.4602) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="imgWrp me-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
              >
                <circle cx="32" cy="32" r="32" fill="#D9D9D9" />
                <path
                  d="M32.2576 22H20.8939C20.3917 22.0002 19.9101 22.1998 19.5549 22.5549C19.1998 22.9101 19.0002 23.3917 19 23.8939V39.0455C19.0002 39.5477 19.1998 40.0293 19.5549 40.3845C19.9101 40.7396 20.3917 40.9392 20.8939 40.9394H26.197C25.9451 40.0781 25.8176 39.1852 25.8182 38.2879C25.8182 38.1629 25.822 38.0341 25.8258 37.9091H22.7879C22.5871 37.9085 22.3948 37.8285 22.2528 37.6865C22.1109 37.5446 22.0309 37.3523 22.0303 37.1515C22.0317 36.951 22.112 36.7592 22.2538 36.6174C22.3955 36.4757 22.5874 36.3954 22.7879 36.3939H26.0076C26.1685 35.6059 26.4308 34.8419 26.7879 34.1212H22.7879C22.5871 34.1206 22.3948 34.0406 22.2528 33.8987C22.1109 33.7567 22.0309 33.5644 22.0303 33.3636C22.0317 33.1632 22.112 32.9713 22.2538 32.8295C22.3955 32.6878 22.5874 32.6075 22.7879 32.6061H27.7159C28.3885 31.7104 29.2143 30.9409 30.1553 30.3333H22.7879C22.5871 30.3327 22.3948 30.2527 22.2528 30.1108C22.1109 29.9688 22.0309 29.7765 22.0303 29.5758C22.0317 29.3753 22.112 29.1834 22.2538 29.0417C22.3955 28.8999 22.5874 28.8196 22.7879 28.8182H30.3636C30.5644 28.8188 30.7567 28.8988 30.8987 29.0407C31.0406 29.1827 31.1206 29.375 31.1212 29.5758C31.1222 29.6544 31.1094 29.7326 31.0833 29.8068C32.0443 29.3234 33.0829 29.0131 34.1515 28.8902V23.8939C34.1513 23.3917 33.9517 22.9101 33.5966 22.5549C33.2414 22.1998 32.7598 22.0002 32.2576 22ZM30.8977 26.322C30.8283 26.3932 30.7452 26.4497 30.6534 26.4881C30.5617 26.5265 30.4631 26.546 30.3636 26.5455H22.7879C22.5871 26.5449 22.3948 26.4649 22.2528 26.3229C22.1109 26.181 22.0309 25.9886 22.0303 25.7879C22.0317 25.5874 22.112 25.3955 22.2538 25.2538C22.3955 25.112 22.5874 25.0317 22.7879 25.0303H30.3636C30.5644 25.0309 30.7567 25.1109 30.8987 25.2528C31.0406 25.3948 31.1206 25.5871 31.1212 25.7879C31.1217 25.8873 31.1022 25.9859 31.0638 26.0777C31.0254 26.1694 30.9689 26.2525 30.8977 26.322Z"
                  fill="#534F4F"
                />
                <path
                  d="M35.2878 29.5757C33.5647 29.5757 31.8803 30.0866 30.4476 31.0439C29.0149 32.0012 27.8983 33.3619 27.2389 34.9538C26.5795 36.5458 26.4069 38.2975 26.7431 39.9875C27.0792 41.6774 27.909 43.2298 29.1274 44.4482C30.3458 45.6666 31.8982 46.4964 33.5882 46.8325C35.2781 47.1687 37.0299 46.9962 38.6218 46.3368C40.2137 45.6774 41.5744 44.5607 42.5317 43.128C43.489 41.6953 43.9999 40.0109 43.9999 38.2878C43.997 35.9781 43.0782 33.7638 41.445 32.1306C39.8118 30.4974 37.5975 29.5786 35.2878 29.5757ZM39.5719 36.1439L37.4317 38.2878L39.5719 40.4317C39.8543 40.7158 40.0126 41.1003 40.012 41.5009C40.0115 41.9015 39.8521 42.2855 39.5688 42.5688C39.2855 42.8521 38.9015 43.0115 38.5009 43.012C38.1003 43.0126 37.7158 42.8543 37.4317 42.5719L35.2878 40.4317L33.1439 42.5719C32.8598 42.8543 32.4753 43.0126 32.0747 43.012C31.6741 43.0115 31.2901 42.8521 31.0068 42.5688C30.7235 42.2855 30.5641 41.9015 30.5636 41.5009C30.563 41.1003 30.7213 40.7158 31.0037 40.4317L33.1439 38.2878L31.0037 36.1439C30.7199 35.8601 30.5605 35.4751 30.5605 35.0738C30.5605 34.6724 30.7199 34.2875 31.0037 34.0037C31.2875 33.7199 31.6724 33.5605 32.0738 33.5605C32.4751 33.5605 32.8601 33.7199 33.1439 34.0037L35.2878 36.1439L37.4317 34.0037C37.5723 33.8632 37.7391 33.7517 37.9227 33.6757C38.1063 33.5996 38.3031 33.5605 38.5018 33.5605C38.7006 33.5605 38.8973 33.5996 39.0809 33.6757C39.2645 33.7517 39.4314 33.8632 39.5719 34.0037C39.7124 34.1442 39.8239 34.3111 39.8999 34.4947C39.976 34.6783 40.0151 34.8751 40.0151 35.0738C40.0151 35.2725 39.976 35.4693 39.8999 35.6529C39.8239 35.8365 39.7124 36.0033 39.5719 36.1439Z"
                  fill="#534F4F"
                />
              </svg>
            </div>
            <div className="content">
              <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                {data?.totalRejectedBookings}
              </h4>
              <p className="m-0 fw-sbold">Total Bookings Rejected </p>
            </div>
          </div>
          </Link>
        </Col>
        <Col lg="4" sm="6" className="my-2">
          <Link to="/booking/my-bookings" className="h-100 text-dark">
          <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative h-100">
            <span
              className="icn position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 22 22"
                fill="none"
              >
                <rect
                  x="21.8438"
                  y="21.896"
                  width="21.4808"
                  height="21.4808"
                  rx="10.7404"
                  transform="rotate(-180 21.8438 21.896)"
                  fill="#467912"
                />
                <g clip-path="url(#clip0_0_2329)">
                  <path
                    d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_2329">
                    <rect
                      width="7.43568"
                      height="7.43567"
                      fill="white"
                      transform="translate(15.2343 14.4602) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="imgWrp me-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
              >
                <circle cx="32" cy="32" r="32" fill="#D9D9D9" />
                <path
                  d="M26.4194 33.0555C26.7663 32.6577 26.4837 32.0365 25.9559 32.0365H24.3757C24.3654 31.8801 24.3596 31.7226 24.3596 31.5637C24.3596 27.6264 27.5628 24.4233 31.5 24.4233C33.3921 24.4233 35.1143 25.1632 36.3933 26.3687L38.6217 23.7618C36.671 21.9774 34.1607 21 31.5 21C28.6783 21 26.0256 22.0988 24.0304 24.094C22.0352 26.0892 20.9364 28.742 20.9364 31.5636C20.9364 31.7218 20.9403 31.8794 20.9472 32.0364H19.6161C19.0883 32.0364 18.8058 32.6576 19.1526 33.0555L22.1553 36.4997L22.786 37.2232L25.0504 34.6257L26.4194 33.0555Z"
                  fill="#534F4F"
                />
                <path
                  d="M43.8472 31.046L41.6076 28.477L40.2138 26.8783L38.2238 29.1609L36.5804 31.046C36.2336 31.4438 36.5161 32.065 37.0439 32.065H38.6223C38.3641 35.7692 35.2684 38.704 31.4998 38.704C29.8547 38.704 28.338 38.1445 27.1293 37.2061L24.9009 39.8132C26.7677 41.3124 29.071 42.1273 31.4999 42.1273C34.3215 42.1273 36.9743 41.0285 38.9695 39.0332C40.8461 37.1567 41.9294 34.6984 42.0516 32.0651H43.3837C43.9115 32.065 44.194 31.4438 43.8472 31.046Z"
                  fill="#534F4F"
                />
              </svg>
            </div>
            <div className="content">
              <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                {data?.totalOngoingBookings}
              </h4>
              <p className="m-0 fw-sbold">Total Booking Ongoing</p>
            </div>
          </div>
          </Link>
        </Col>
        <Col lg="4" sm="6" className="my-2">
          <Link to="/booking/booking-request" className="h-100 text-dark">
          <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative h-100">
            <span
              className="icn position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 22 22"
                fill="none"
              >
                <rect
                  x="21.8438"
                  y="21.896"
                  width="21.4808"
                  height="21.4808"
                  rx="10.7404"
                  transform="rotate(-180 21.8438 21.896)"
                  fill="#467912"
                />
                <g clip-path="url(#clip0_0_2329)">
                  <path
                    d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_2329">
                    <rect
                      width="7.43568"
                      height="7.43567"
                      fill="white"
                      transform="translate(15.2343 14.4602) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="imgWrp me-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
              >
                <circle cx="32" cy="32" r="32" fill="#D9D9D9" />
                <path
                  d="M27.9643 31.2145C28.4524 30.7264 29.2438 30.7264 29.7321 31.2145L31.4998 32.9822L33.2676 31.2145C33.7558 30.7264 34.5472 30.7264 35.0353 31.2145C35.5236 31.7026 35.5236 32.4941 35.0353 32.9822L33.2676 34.75L35.0353 36.5177C35.5234 37.0059 35.5234 37.7974 35.0353 38.2855C34.5472 38.7737 33.7557 38.7737 33.2676 38.2855L31.4998 36.5177L29.7321 38.2855C29.2439 38.7737 28.4525 38.7737 27.9643 38.2855C27.4762 37.7974 27.4762 37.006 27.9643 36.5177L29.7321 34.75L27.9643 32.9822C27.4761 32.4941 27.4761 31.7026 27.9643 31.2145Z"
                  fill="#534F4F"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19 24.75C19 22.6789 20.6789 21 22.75 21H40.25C42.3211 21 44 22.6789 44 24.75V39.75C44 41.8211 42.3211 43.5 40.25 43.5H22.75C20.6789 43.5 19 41.8211 19 39.75V24.75ZM41.5 28.5H21.5V39.75C21.5 40.4404 22.0596 41 22.75 41H40.25C40.9404 41 41.5 40.4404 41.5 39.75V28.5Z"
                  fill="#534F4F"
                />
              </svg>
            </div>
            <div className="content">
              <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                {data?.totalCanceledBookings}
              </h4>
              <p className="m-0 fw-sbold">Total Bookings Canceled </p>
            </div>
          </div>
          </Link>
        </Col>
        <Col lg="4" sm="6" className="my-2">
          <Link to="/booking/booking-request" className="h-100 text-dark">
          <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative h-100">
            <span
              className="icn position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 22 22"
                fill="none"
              >
                <rect
                  x="21.8438"
                  y="21.896"
                  width="21.4808"
                  height="21.4808"
                  rx="10.7404"
                  transform="rotate(-180 21.8438 21.896)"
                  fill="#467912"
                />
                <g clip-path="url(#clip0_0_2329)">
                  <path
                    d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_2329">
                    <rect
                      width="7.43568"
                      height="7.43567"
                      fill="white"
                      transform="translate(15.2343 14.4602) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="imgWrp me-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
              >
                <circle cx="32" cy="32" r="32" fill="#D9D9D9" />
                <path
                  d="M37.314 28.0714C40.916 32.8573 37.2804 40.0697 31.2351 39.9773C27.0957 39.9773 23.7288 36.6104 23.7288 32.4711C23.6532 27.6264 28.4895 23.9236 33.141 25.2083L29.2452 31.6986C28.9345 32.0428 29.0017 34.4778 28.9261 34.9815C28.8421 35.9555 30.0176 36.6608 30.832 36.1234C31.1763 35.8632 33.4685 34.6961 33.5692 34.3098L37.314 28.0714ZM31.6717 23.487L31.6381 21.9085L30.7985 21.9253L30.832 23.5038L31.6717 23.487ZM26.3065 24.906L25.3493 23.6466L24.686 24.1587L25.6431 25.4182L26.3065 24.906ZM21.042 29.5575L22.5533 30.0109L22.7968 29.2049L21.2855 28.7515L21.042 29.5575ZM21 35.2754L21.2771 36.0647L22.7716 35.5441L22.4945 34.7548L21 35.2754ZM24.602 40.7162L25.2905 41.1948L26.1889 39.8934L25.5004 39.4148L24.602 40.7162ZM30.6809 41.4215L30.7145 43L31.5541 42.9832L31.5205 41.4047L30.6809 41.4215ZM36.0461 40.0025L37.0033 41.262L37.6666 40.7498L36.7095 39.4904L36.0461 40.0025ZM39.5474 35.6952L41.0587 36.1486L41.3022 35.3426L39.7909 34.8892L39.5474 35.6952ZM39.5726 29.356L39.8497 30.1453L41.3442 29.6247L41.0671 28.8355L39.5726 29.356ZM41.4198 22.765L39.8581 25.351L39.1444 24.9228L40.6977 22.3367C40.916 21.9421 40.5298 21.7238 40.2359 21.5643L39.3879 22.9749L36.4911 21.2452C36.7682 20.7918 37.6834 19.2637 37.9437 18.8271C39.3207 16.812 42.1334 18.8691 40.6725 20.8422C41.0587 21.0521 41.4701 21.3544 41.5625 21.8078C41.6381 22.1352 41.5877 22.4795 41.4198 22.765ZM38.6574 19.2637L38.4895 19.5408L39.9168 20.3972L39.9504 20.414L40.1183 20.1369C40.6725 19.1713 39.2535 18.3149 38.6574 19.2637ZM33.9555 25.4686C33.1326 26.9295 30.597 30.8926 29.8917 32.3199L29.7573 35.0151C29.7405 35.351 30.1016 35.5693 30.3954 35.4014L32.696 34.0076C34.5684 31.1528 37.1461 26.6188 38.9513 23.6969L36.0629 21.9589L33.9555 25.4686Z"
                  fill="#534F4F"
                />
              </svg>
            </div>
            <div className="content">
              <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                {data?.totalGeneratedBookings}
              </h4>
              <p className="m-0 fw-sbold">Total Bookings Generated </p>
            </div>
          </div>
          </Link>
        </Col>
      </Row>
    </>
  );
};

export default EarningFeature;
